import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type OrganizationState = {
  data: unknown;
};

const initialState: OrganizationState = {
  data: null,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganizationData: (state, action: PayloadAction<unknown>) => {
      state.data = action.payload;
    },
    clearOrganizationData: (state) => {
      state.data = null;
    },
  },
});

export const { setOrganizationData, clearOrganizationData } = organizationSlice.actions;
export default organizationSlice.reducer;
